<script setup>
import { computed, defineProps } from 'vue'

const props = defineProps({
  value: {
    type: [Number, String],
    required: true,
  },
  position: {
    type: String,
    required: true,
    validator: (v) => ['top', 'bottom'].includes(v),
  },
  zIndex: {
    type: [Number, String],
    default: 1,
  },
  flipType: {
    type: String,
    default: '',
  },
  textStyle: {
    type: Object,
    required: true,
  },
  elRef: {
    type: [Function, Object],
    default: null,
  },
})

const digitClasses = 'absolute w-full h-1/2 bg-joe-cr-blue-primary select-none overflow-hidden'
const digitTextClasses = 'absolute w-full flex items-center justify-center font-geomanist font-bold text-white leading-none left-0 tracking-wider uppercase select-none'
const digitInnerShadow = 'absolute opacity-60 inset-0 shadow-inner shadow-joe-cr-blue-darker'

const partClasses = computed(() => {
  let base = digitClasses
  if (props.position === 'top') {
    base += ' rounded-t-2xl border-b-2 border-joe-cr-blue-darker'
  } else {
    base += ' rounded-b-2xl'
  }
  base += ` z-[${props.zIndex}]`
  base += props.position === 'top' ? ' top-0' : ' bottom-0'
  if (props.flipType) {
    base += ` transition-opacity duration-75 ${props.position === 'top' ? 'origin-[center_bottom]' : 'origin-[center_top]'}`
    base += ` ${props.flipType}`
  }
  if (props.flipType === 'flipping-bottom') {
    base += ` drop-shadow-[0_80px_36px_black]`
  }
  return base
})

const textStyle = computed(() => {
  return {
    ...props.textStyle,
    top: props.position === 'top' ? props.textStyle.top ?? '0' : props.textStyle.bottom ?? props.textStyle.top ?? '0',
  }
})

const element = ref(null)

defineExpose({ element })
</script>

<template>
  <div ref="element" :class="partClasses">
    <span :class="digitTextClasses" :style="textStyle">
      {{ value }}
    </span>
    <div :class="[digitInnerShadow, position === 'top' ? 'rotate-180' : '']" />
  </div>
</template>
